import { jwtDecode } from 'jwt-decode'

/*
 * A composable that reads the potential Draft Mode cookie, and decodes the JWT
 * token. It is designed for client-side use, so it does not validate the token:
 * any well-constructed JWT will return a positive response, even if it wasn't
 * actually generated by the server.
 *
 * It's not a security issue, because the worst thing that could happen is that
 * the malicious user trying to forge a token, will see the website not
 * functioning.
 */
export function useDraftMode() {
  const config = useRuntimeConfig()
  const cookie = useCookie(config.public.draftModeCookieName)

  if (!cookie.value) {
    return false
  }

  try {
    return jwtDecode<{ datocmsDraftContentCdaToken: string }>(cookie.value)
  } catch {
    return false
  }
}
